import {
  getTheme,
  mergeStyleSets,
  FontWeights,
  ContextualMenu,
  Toggle,
  Modal,
  IDragOptions,
  IIconProps,
  Stack,
  IStackProps,
  Spinner,
} from "@fluentui/react";
import {
  DefaultButton,
  IconButton,
  IButtonStyles,
  PrimaryButton,
} from "@fluentui/react/lib/Button";
import React, { useEffect, useState } from "react";

import "./ModalDialog.scss";

export interface ModalDialogButtonInfo {
  onClick?: () => void;
  label: string;
  disabled?: boolean;
}

export interface IModalDialogProps {
  enableModal: boolean;
  modalButtons?: ModalDialogButtonInfo[];
  modalTitle?: string;
  modalMessage?: string;
  modalInnerComponent?: any;
  onAccept?: () => void;
  onAbort?: () => void;
  loadingButtons?: boolean;
}

export const ModalDialog = (props: IModalDialogProps) => {
  let buttons = props.modalButtons ?? [];

  if (buttons.length === 0) {
    if (props.onAbort && props.onAccept) {
      buttons.push({ onClick: props.onAbort, label: "Cancella" });
    }
    if (props.onAbort && !props.onAccept) {
      buttons.push({ onClick: props.onAbort, label: "Chiudi" });
    }
    if (props.onAccept) {
      buttons.push({ onClick: props.onAccept, label: "Avanti" });
    }
  }

  let title = props.modalTitle ?? "";
  let abortFunction = props.onAbort ?? (() => {});

  return (
    <div>
      <Modal
        titleAriaId={title}
        isOpen={props.enableModal}
        onDismiss={abortFunction}
        isBlocking={true}
        containerClassName={"modal-dialog-main-wrap"}
        dragOptions={undefined}
      >
        <div className={contentStyles.header}>
          <span className="modal-dialog-title">{title}</span>
          <IconButton
            styles={iconButtonStyles}
            iconProps={cancelIcon}
            ariaLabel="Close popup modal"
            onClick={abortFunction}
          />
        </div>
        <div className={contentStyles.body}>
          {props.modalMessage && (
            <div
              className="modal-dialog-message"
              dangerouslySetInnerHTML={{ __html: props.modalMessage }}
            ></div>
          )}
          {props.modalInnerComponent && (
            <div className="modal-dialog-inner-component">
              {props.modalInnerComponent}
            </div>
          )}
          <div className="modal-dialog-button-main-wrap">
            <div></div>
            {props.loadingButtons === true && (
              <div>
                <Spinner label={"Processing..."} labelPosition={"right"} />
              </div>
            )}
            {props.loadingButtons !== true && (
              <div className="modal-dialog-button-wrap">
                {buttons.map((x: ModalDialogButtonInfo, i: number) => {
                  return (
                    <span key={i} className="modal-dialog-button-inner-wrap">
                      {i !== buttons.length - 1 && (
                        <DefaultButton
                          disabled={x.disabled}
                          onClick={x.onClick ?? (() => {})}
                          text={x.label}
                        />
                      )}
                      {i === buttons.length - 1 && (
                        <PrimaryButton
                          disabled={x.disabled}
                          onClick={x.onClick ?? (() => {})}
                          text={x.label}
                        />
                      )}
                    </span>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ModalDialog;

const cancelIcon: IIconProps = { iconName: "Cancel" };

const theme = getTheme();
const contentStyles = mergeStyleSets({
  container: {
    display: "flex",
    flexFlow: "column nowrap",
    alignItems: "stretch",
  },
  header: [
    {
      flex: "1 1 auto",
      color: theme.palette.neutralPrimary,
      display: "flex",
      alignItems: "center",
      fontSize: "20px",
      fontWeight: "600",
      padding: "12px 12px 14px 24px",
    },
  ],
  body: {
    flex: "4 4 auto",
    padding: "0 24px 24px 24px",
    fontWeight: "400",
    fontSize: "14px",
    overflowY: "hidden",
    selectors: {
      p: { margin: "14px 0" },
      "p:first-child": { marginTop: 0 },
      "p:last-child": { marginBottom: 0 },
    },
  },
});
const iconButtonStyles: Partial<IButtonStyles> = {
  root: {
    color: theme.palette.neutralPrimary,
    marginLeft: "auto",
    marginTop: "4px",
    marginRight: "2px",
  },
  rootHovered: {
    color: theme.palette.neutralDark,
  },
};
